import { isProd } from '@/uikit/utils/helpers';

const getMessage = (validationObject: any): string => {
  const validators = Object.keys(validationObject).filter(
    (el) => !/\$/gim.test(el)
  );
  const validatorName = validators.find((el) => !validationObject[el]) || '';
  if (validatorName) return validationObject?.$params[validatorName]?.$message;
  else return '';
};

const getMessages = (validationObject: any): Array<string> => {
  const validators = Object.keys(validationObject).filter(el => !/\$/gmi.test(el));

  const foundedActiveValidators =
    validators.filter((el) => !validationObject[el]) || [];
  if (!isProd) {
    console.log(foundedActiveValidators);
  }
  const messages = foundedActiveValidators
    .map((el) => validationObject?.$params[el]?.$message || '')
    ?.filter((el) => !!el);

  if (!messages.length) {
    console.warn('Cannot Find Validator Messages in ', validationObject);
  }
  return messages;
};

export { getMessage, getMessages };



// WEBPACK FOOTER //
// ./src/tools/validators/getMessage.ts